module.exports = {
  pathPrefix: '/', // Prefix for all links. If you deploy your site to example.com/portfolio your pathPrefix should be "portfolio"
  siteTitle: 'Alex Bernson', // Navigation and Site Title
  siteTitleAlt: 'Alex Bernson', // Alternative Site title for SEO
  siteTitleShort: 'Alex', // short_name for manifest
  siteUrl: 'https://alexbernson.com', // Domain of your site. No trailing slash!
  siteLanguage: 'en', // Language Tag on <html> element
  siteLogo: '/me.jpg', // Used for SEO and manifest
  siteDescription: 'A collection of things Alex Bernson has worked on.',
  author: 'Alex Bernson', // Author for schemaORGJSONLD

  // siteFBAppID: '123456789', // Facebook App ID - Optional
  userTwitter: '@alexbernson', // Twitter Username
  ogSiteName: 'Alex Bernson', // Facebook Site Name
  ogLanguage: 'en_US',
  googleAnalyticsID: 'UA-107805638-2',

  // Manifest and Progress color
  themeColor: '#528D81',
  backgroundColor: '#528D81',
}
